var React = require('react');

function Uranus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.715 4l-3.836 3.923 1.372 1.342 1.615-1.651v5.14c-3.874.507-6.851 3.816-6.851 7.771 0 4.3 3.518 7.846 7.883 7.846 4.364 0 7.88-3.545 7.88-7.846 0-4.004-3.049-7.35-6.992-7.792v-5l1.508 1.476 1.342-1.373-2.85-2.787L15.715 4zm.183 10.557c3.257 0 5.918 2.64 5.918 5.968s-2.66 5.966-5.918 5.966-5.922-2.638-5.922-5.966c0-3.328 2.664-5.967 5.921-5.967zm0 4.245a1.73 1.73 0 100 3.459 1.73 1.73 0 000-3.459z"}));
}

Uranus.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Uranus;

Uranus.default = Uranus;
